import progressReport from '../reports/progress-gr1-6-2023-07/index.js'
import provincialReport from '../reports/provincial-gr1-6-2023-09/index.js'

const REGISTRY = {
  [progressReport.key]: progressReport,
  [provincialReport.key]: provincialReport,
}

export async function generatePdf(reportTypeKey, formData, options = {}) {
  const entry = REGISTRY[reportTypeKey]
  if (!entry) throw new Error(`Unknown report type: ${reportTypeKey}`)
  return entry.fill(formData, options)
}

export function getTemplateUrl(reportTypeKey) {
  return REGISTRY[reportTypeKey]?.templateUrl
}
